import React, { createContext, useEffect, useState } from 'react'

import NavBar from './Components/NavComp';
import { BrowserRouter, Route, Routes, Link } from 'react-router-dom';
import Home from './pages/Home';
import Electronics from './pages/Electronics';
import Jewellery from './pages/Jewellery';
import Mens from './pages/Mens';
import Womens from './pages/Womens';
import Footer from './Components/Footer';
import CartPage from './pages/CartPage';
import CartButton from './Components/CartButton';
import SingleProduct from './pages/SingleProduct';
import { IndexRouteObject } from 'react-router-dom';


const AppContext = createContext();
const App = (props) => {


  const [cart, setCart] = useState({ items: {}, itemsCount: 0, totalPrice: 0});

  useEffect(() => {
    new Promise((resolve, reject) => {
      const cart = window.localStorage.getItem('cart');
      resolve(cart);
    }).then(cart => {
      if(cart!=undefined)
      setCart(JSON.parse(cart));
    })
  }
  ,[]);

  useEffect(() => {
    window.localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);



  return (
    <>
      <AppContext.Provider value={[cart, setCart]}>
        <BrowserRouter>
          <NavBar />
          <Routes>

            <Route path='Online-Adda-E-Commerce' index element={< Home data={props.AllProducts}
              ElectronicProducts={props.ElectronicProducts}
              JewelleryProducts={props.JewelleryProducts}
              MensProducts={props.MensProducts}
              WomensProducts={props.WomensProducts}
            />}></Route>

            <Route path='/'  element={< Home data={props.AllProducts}
              ElectronicProducts={props.ElectronicProducts}
              JewelleryProducts={props.JewelleryProducts}
              MensProducts={props.MensProducts}
              WomensProducts={props.WomensProducts}
            />}></Route>


            <Route path='/Electronics' element={< Electronics Products={props.ElectronicProducts} />}></Route>
            <Route path='/Jewellery' element={< Jewellery Products={props.JewelleryProducts} />}></Route>
            <Route path='/Mens' element={<Mens Products={props.MensProducts} />} />
            <Route path='/Womens' element={<Womens Products={props.WomensProducts} />} />
            <Route path="/CartPage" element={<CartPage data={props.AllProducts} />} />
            <Route path="SingleProduct/:id"  element={<SingleProduct  data={props.AllProducts} />} />
          </Routes>
          <CartButton />
          <Footer />

        </BrowserRouter>
      </AppContext.Provider>
    </>
  )
}

export default App;
export { AppContext };
